import { ActionReducerMap } from '@ngrx/store';

import * as fromGlobal from './global';
import * as fromRemotePickup from './remote-pickup';
import * as fromSettings from './settings';
import * as fromSpaces from './spaces';

export interface State {
  global: fromGlobal.GlobalState;
  spaces: fromSpaces.SpacesState;
  settings: fromSettings.SettingsState;
  remotePickup: fromRemotePickup.RemotePickupState;
}

export const reducers: ActionReducerMap<State> = {
  spaces: fromSpaces.reducer,
  global: fromGlobal.reducer,
  settings: fromSettings.reducer,
  remotePickup: fromRemotePickup.reducer,
};
